import { defineMessages } from 'react-intl'

/**
 * All user-facing copy for deleting a draft Care Referral (LCDELIVERY-7932). Follows the Figma MVP
 * designs ("Current state - add delete functionality") and the modal error state design.
 */
export const CARE_REFERRAL_DELETE_MESSAGES = defineMessages({
  modalTitle: {
    defaultMessage: 'Delete care referral draft?',
    description: 'Title of the confirmation modal shown before deleting a draft Care Referral form',
  },
  modalBody: {
    defaultMessage:
      'The care referral draft for {clientName} will be permanently deleted. Save any clinically relevant details to a general note before continuing.',
    description:
      'Body of the confirmation modal shown before deleting a draft Care Referral form. clientName is the name of the client the draft is for',
  },
  confirmButton: {
    defaultMessage: 'Delete draft',
    description: 'Button that confirms deleting a draft Care Referral form',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Button that closes the delete confirmation modal without deleting the Care Referral form',
  },
  successToast: {
    defaultMessage: 'Care referral draft deleted',
    description: 'Toast shown after a draft Care Referral form is deleted',
  },
  errorBanner: {
    defaultMessage: "Something went wrong and your draft wasn't deleted. Please try again in a moment.",
    description:
      'Inline error shown inside the delete confirmation modal when deleting a draft Care Referral form fails',
  },
})
